/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberGradeOption
 */
export interface MemberGradeOption {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof MemberGradeOption
     */
    id?: number;
    /**
     * 会员等级韩文名称
     * @type {string}
     * @memberof MemberGradeOption
     */
    nameKr?: string;
    /**
     * 会员等级中文名称
     * @type {string}
     * @memberof MemberGradeOption
     */
    nameCn?: string;
}

/**
 * Check if a given object implements the MemberGradeOption interface.
 */
export function instanceOfMemberGradeOption(value: object): value is MemberGradeOption {
    return true;
}

export function MemberGradeOptionFromJSON(json: any): MemberGradeOption {
    return MemberGradeOptionFromJSONTyped(json, false);
}

export function MemberGradeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberGradeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
    };
}

export function MemberGradeOptionToJSON(json: any): MemberGradeOption {
    return MemberGradeOptionToJSONTyped(json, false);
}

export function MemberGradeOptionToJSONTyped(value?: MemberGradeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
    };
}

